import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@nusign/picflow-backend-types';

const getAssetStatusButtonColor = (status: AssetStatus): string => {
  if (status === 'approved') return 'green';
  if (status === 'in_progress') return 'blue';
  if (status === 'needs_review') return 'orange';
  if (status === 'rejected') return 'warn';
};

@Pipe({
  name: 'assetStatusButtonColor',
  standalone: true,
})
export class AssetStatusButtonColorPipe implements PipeTransform {
  transform(status: AssetStatus, full = false): string {
    const color = getAssetStatusButtonColor(status);
    if (!color) return;
    return full ? color : `simple-${color}`;
  }
}
